// extracted by mini-css-extract-plugin
module.exports = {"tab-item":"TabItem-module__tab-item__1gmK0","label":"TabItem-module__label__1xlYM","selected":"TabItem-module__selected__u8WVU"};